import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectors } from "reducers";
import Message from "./message";

const MessageList = ({ messages, userId, readInfo }) => {
  const messageListRef = React.useRef();

  React.useEffect(() => {
    messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
  }, [messages]);

  const lastSentMessageIndex = [...messages]
    .reverse()
    .find(msg => msg.author === userId)?.index;

  return (
    <div
      className="messages-container"
      ref={messageListRef}
      style={{ overflow: "scroll", minHeight: "45vh" }}
    >
      {messages.map((msg, i) => (
        <Message
          key={i}
          {...msg}
          userId={userId}
          readInfo={readInfo}
          isLastSent={msg.index === lastSentMessageIndex}
        />
      ))}
    </div>
  );
};

MessageList.propTypes = {
  userId: PropTypes.string.isRequired,
  messages: PropTypes.arrayOf(PropTypes.object),
  readInfo: PropTypes.object
};

export default connect(state => ({ userId: selectors.getUserId(state) }))(
  MessageList
);
